/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserHandlerSelectionsRequestActionCreator, deleteUserHandlerSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { handlerCheckedActionCreator } from '../redux/actions/HandlerActions';
import Icons from '../../../../core/modules/common/components/Icons';
import DeleteModal from '../../../common/components/DeleteModal';

const mapStateToProps = state => ({
  selections: state.handlerSelector.handler.selections,
});

export class HandlerSelectionSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSelection: 'Your last selection',
      showDeleteSelectionModal: false,
      name: '',
    };
  }

  componentDidMount() {
    this.props.fetchUserHandlerSelectionsRequestActionCreator();
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  applySelection = (e, selection) => {
    this.props.handlerCheckedActionCreator(selection.handlers);
    this.setState({
      activeSelection: selection.name,
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      name: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteUserHandlerSelectionRequestActionCreator(this.state.name);
    this.onCloseModal();
  };

  render() {
    const {
      selections,
    } = this.props;
    return (
      <div className="operator-sidebar-div">
        <div className="selection-title">
          <FormattedMessage
            tagName="h5"
            id="app.selection.list.title.handler"
          />
        </div>
        {selections && selections.length > 0 ? (
          <div className="user-selections">
            {this.state.showDeleteSelectionModal &&
              <DeleteModal
                headerFormattedMessageId="app.warning.delete.save.operator.selection"
                onCloseModal={this.onCloseModal}
                deleteSelection={this.deleteSelection}
              />
            }
            <ul>
              { selections
                  .filter(selection => selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state.activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="delete-icon"
                        key={selection.name}
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      {selection.name}
                    </li>
              )) }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserHandlerSelectionsRequestActionCreator,
  deleteUserHandlerSelectionRequestActionCreator,
  handlerCheckedActionCreator,
}, dispatch);

HandlerSelectionSidebarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    handlers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  fetchUserHandlerSelectionsRequestActionCreator: PropTypes.func,
  deleteUserHandlerSelectionRequestActionCreator: PropTypes.func,
  handlerCheckedActionCreator: PropTypes.func,
};

export const ConnectedHandlerSelectionSidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HandlerSelectionSidebarContainer);

export default (ConnectedHandlerSelectionSidebarContainer);
